<template>
  <v-snackbar
    v-model="snackbar.visible"
    location="right top"
    transition="scroll-x-reverse-transition"
    :color="snackbar.type"
    :timeout="snackbar.timeout"
    elevation="24"
  >
    <div>
      <v-icon
        size="large"
        :icon="`fa-solid ${icons[snackbar.type]}`"
        class="mr-2"
        density="compact"
      />
      {{ snackbar.message }}
    </div>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useSnackBar } from '../stores/snackbar'

export default defineComponent({
  data() {
    return {
      snackbar: useSnackBar(),
      icons: {
        success: 'fa-badge-check',
        info: 'fa-circle-info',
        warning: 'fa-triangle-exclamation',
        error: 'fa-circle-xmark',
      },
    }
  },
})
</script>
